import { isEmpty } from 'lodash'
import React from 'react'
import {Nav, NavItem} from 'reactstrap'
const EntityTabs = ({activeTab, handleTab, allTabs}) => {


    const isActive = (tab) => {
        return activeTab.key == tab.key
    }

  return (
    <React.Fragment>
        <Nav className='mb-0'>
          {!isEmpty(allTabs) && allTabs.map((tab) => {
            return (
              <NavItem className='me-4' key={tab.key}>
                <p
                    role='button'
                    className={isActive(tab) ? 'border-5 border-bottom border-success' : 'border-bottom border-light'}
                    onClick={() => handleTab(tab)}
                >
                  {tab.displayName}
                </p>
              </NavItem>
            )
          })}
        </Nav>
    </React.Fragment>
  )
}

export default EntityTabs